import Vue from 'vue';

import {
    Cascader
} from 'element-ui';
import { isEqual, isEmpty, kebabCase } from 'element-ui/src/utils/util';

export const JtLabelCascader = Vue.extend({
    name:'JtLabelCascader',
    extends: Cascader,
    data() {
        return {
            deleteLabels: [],
        };
    },
    props:{
        removeDelete:{
            type:Boolean,
            default:true,
        },
    },
    mounted(){
        this.$nextTick(()=>{
            this.deleteLabels = this.$attrs.deleteLabels||[];
            this.computePresentTags();
        })
    },
    watch:{

    },
    methods: {
        setDeleteLabels(list){
            this.deleteLabels = [...list];
        },
        computePresentTags() {
            const { isDisabled, leafOnly, showAllLevels, separator, collapseTags } = this;
            const checkedNodes = this.getCheckedNodes(leafOnly);
            const tags = [];

            if(this.deleteLabels.length>0){
                this.deleteLabels.forEach(item=>{
                    tags.push({
                        closable: this.removeDelete,
                        hitState:false,
                        key: item.id,
                        text: item.name,
                        node:null,
                    })
                });
            }

            const genTag = node => ({
                node,
                key: node.uid,
                text: node.getText(showAllLevels, separator),
                hitState: false,
                closable: !isDisabled && !node.isDisabled
            });

            if (checkedNodes.length) {
                const [first, ...rest] = checkedNodes;
                const restCount = rest.length;
                tags.push(genTag(first));

                if (restCount) {
                    if (collapseTags) {
                        tags.push({
                            key: -1,
                            text: `+ ${restCount}`,
                            closable: false
                        });
                    } else {
                        rest.forEach(node => tags.push(genTag(node)));
                    }
                }
            }

            this.checkedNodes = checkedNodes;
            this.presentTags = tags;
        },
        deleteTag(tag) {
            const { checkedValue } = this;
            if(!tag.node){

                let index =  this.presentTags.findIndex(item=>item.key==tag.key);
                let index2 = this.deleteLabels.findIndex(item=>item.id==tag.key);
                if(index!=-1){
                    this.presentTags.splice(index,1);
                }
                if(index2!=-1){
                    this.deleteLabels.splice(index2,1);
                }

                this.$emit('remove-delete-tag', tag);
            }else{

                const current = tag.node.getValueByOption();
                const val = checkedValue.find(n => isEqual(n, current));
                this.checkedValue = checkedValue.filter(n => !isEqual(n, current));
                this.$emit('remove-tag', val);
            }
        },
    }
});
